//  this file contains feature names to be used for sending to Amplitude as events

/* eslint-disable import/prefer-default-export */
export const EVENT_NAMES = {
  // AUTH_FEATURES
  USER_SIGNEDIN: "user_signedin",
  USER_SIGNUP: "user_signup",
  SIGNUP_VIEWED: "signup_viewed",
  // DASHBOARD_FEATURES
  DASHBOARD_PAGE_VIEWED: "dashboard_page_viewed",

  // PIPELINE_FEATURES
  PIPELINE_PAGE_VIEWED: "pipeline_page_viewed",

  // ASSETS_FEATURES
  ASSETS_PAGE_VIEWED: "assets_page_viewed",

  // PRICEBOOK_FEATURES
  PRICEBOOK_PAGE_VIEWED: "pricebook_page_viewed",

  // PRODUCT_FEATURES
  PRODUCT_PAGE_VIEWED: "product_page_viewed",
  PRODUCT_CREATED: "product_created",
  // DOCUMENT_FEATURES
  CREATE_DOC_CLICKED: "create_doc_clicked",
  DOCUMENT_VIEWED: "document_viewed",
  DOCUMENT_CREATED: "document_created",
  INTERNAL_REVIEW: "internal_review",
  CUSTOMER_REVIEW: "customer_review",
  DOCUMENT_SIGNED: "document_signed",
  SIGNATORY_ADDED: "signatory_added",
  SIGNATURE_BLOCK_MISSED: "signature_block_missed",
  REVISION_UPLOADED: "revision_uploaded",
  DOCUMENT_DOWNLOADED: "document_downloaded",
  DOCUMENT_APPROVED: "document_approved",
  DOCUMENT_REJECTED: "document_rejected",
  // PRODUCT_MODIFY_PRODUCT: "product.modify_product",
  // TEMPLATES_FEATURES
  TEMPLATE_CREATED: "template_created",
  TEMPLATES_PAGE_VIEWED: "templates_page_viewed",

  // WORKFLOW_FEATURES
  WORKFLOW_PAGE_VIEWED: "workflow_page_viewed",

  // PRO_EVENTS
  PRO_FEATURE_ACCESSED: "pro_feature_accessed",
  // SETTING_PAGE
  PROFILE_PAGE_VIEWED: "profile_page_viewed",
  ACCOUNT_PAGE_VIEWED: "account_page_viewed",
  TEAMMATES_PAGE_VIEWED: "teammates_page_viewed",
  INTEGRATION_PAGE_VIEWED: "integration_page_viewed",
  AUTHENTICATION_PAGE_VIEWED: "authentication_page_viewed",

  // DEAL_TABLE
  PRODUCT_ADDED: "product_added",

  // INBOX_FEATURES
  INBOX_PAGE_VIEWED: "inbox_page_viewed",

  // INVITE_TEMAMATES
  TEAMMATES_INVITED: "teammates_invited",

  // DOCUMENTATION_HUB
  DOCUMENTATION_HUB_VIEWED: "documentation_hub_viewed",

  // USER_SIGNED_OUT
  USER_SIGNOUT: "user_signout",

  // GROUPING_APPLIED
  DEAL_TABLE_GROUPING_APPLIED: "deal_table_grouping_applied",

  // MODIFIED_GROUPING
  DEAL_TABLE_GROUPING_MODIFIED: "deal_table_grouping_modified",

  // DOCUMENT_STATUS
  COMMENT_ADDED: "comment_added",

  // WORKFLOW_DT_CREATED
  WORKFLOW_DT_CREATED: "workflow_dt_created",

  // WORKFLOW_CLAUSE_OPTION_CREATED
  WORKFLOW_CLAUSE_OPTION_CREATED: "workflow_clause_option_created",

  // TEMPLATE_OPENED
  TEMPLATE_OPENED: "template_opened",

  // TEMPLATE_CLONED
  TEMPLATE_CLONED: "template_cloned",

  // TEMPLATE_PUBLISHED
  TEMPLATE_PUBLISHED: "template_published",

  // TEMPLATE_EDITED
  TEMPLATE_EDITED: "template_edited",

  // ASSET_FEATURE
  FOLDER_CREATED: "folder_created",
  TAGS_CHANGED: "tags_changed",
  STATUS_CHANGED: "status_changed",
  NEW_TAG_ADDED: "new_tag_added",
  TAG_EDITED: "tag_edited",
  NEW_STATUS_ADDED: "new_status_added",
  FOLDER_DELETED: "folder_deleted",
  DOCUMENT_DELETED: "document_deleted",
  FOLDER_RENAMED: "folder_renamed",
  DOCUMENT_RENAMED: "document_renamed",
  COLLABORATORS_ADDED_ON_FOLDER: "collaborators_added_on_folder",
  SHARE_DOCUMENT_CLICKED: "share_document_clicked",
  DOCUMENT_SHARED: "document_shared",
  EDIT_DOCUMENT_CLICKED: "edit_document_clicked",
  DOCUMENT_SENT_FOR_SIGNATURE: "document_sent_for_signature",
  GO_TO_POPUP_CLICKED: "go_to_popup_clicked",
  ESIGN_BUTTON_CLICKED: "esign_button_clicked",
  DOCUMENT_PREVIEW_CLICKED: "document_preview_clicked",

  // NEW_SIGNATURE_FEATURE
  SIGNATURE_BLOCK_ADDED: "signature_block_added",
  SIGNATURE_BLOCK_DELETED: "signature_block_deleted",
  SIGNATURE_BLOCK_EDITED: "signature_block_edited",
  SIGNER_ADDED: "signer_added",
  SIGNER_DELETED: "signer_deleted",

  // GLOBAL_TEMPLATE_FEATURE
  TEMPLATE_LIBRARY_VIEWED: "template_library_viewed",
  TEMPLATE_PREVIEW_CLICKED: "template_preview_clicked",
  TEMPLATE_PREVIEW_CLOSED: "template_preview_closed",
  ADD_TEMPLATE_BUTTON_CLICKED: "add_template_button_clicked",
  TEMPLATE_TAGS_CHANGED: "template_tags_changed",
  TEMPLATE_STATUS_CHANGED: "template_status_changed",
  TEMPLATE_DELETED: "template_deleted",
  TEMPLATE_PREVIEW_NAVIGATION: "template_preview_navigation",
  MY_TEMPLATE_VIEWED: "my_template_viewed",

  // HEARTBEAT ON CLICKING NAVBAR ITEMS
  NAV_BAR_ITEM_CLICKED: "heartbeat",

  // UNSPLASH
  UNSPLASH_BUTTON_CLICKED: "unsplash_button_clicked",
  UNSPLASH_IMAGE_UPLOAD: "unsplash_image_uplaod",
  UNSPLASH_LOAD_MORE_BUTTON_CLICKED: "unsplash_load_more_button_clicked",
  UNSPLASH_SEARCH_IMAGES: "unsplash_search_images",

  // STRIPE PAYMENTS EVENTS
  STRIPE_BLOCK_ADDED: "stripe_block_added",
  STRIPE_BLOCK_DELETED: "stripe_block_deleted",
  STRIPE_BLOCK_SAVED: "stripe_block_saved",
  STRIPE_PAYMENT_BUTTON_CLICKED: "stripe_payment_button_clicked",

  // METALENS EVENTS
  METALENS_ACTIVE: "metalens_activate",
  METALENS_DOWNLOAD: "metalens_download",
  METALENS_ADD_TAG: "metalens_add_tag",
  // CLAUSE ANALYSIS
  CLAUSE_ANALYSIS_REVIEW_TYPE_SELECTED: "review_type_selected",
  CLAUSE_ANALYSIS_CLAUSE_FILTER_SELECTED: "clause_filter_selected",
  CLAUSE_ANALYSIS_RESET_FILTER: "reset_filter",
  CLAUSE_ANALYSIS_FEEDBACK_SUBMITTED: "feedback_submitted",
};



// WEBPACK FOOTER //
// ./src/constants/events.js